<div class="text-center" style="color:red">
   
    <img src="../../../../assets/images/404.png"
    class="card-img-top" style="width:25%">
</div>
